import React, { useEffect, useState } from 'react'
import CamposVentaExportador from './CamposVentaExportador'
import { FORM_VENTA_A_EXPORTADOR } from '../../../../config/forms'
import { reduxForm } from 'redux-form'
import moment from 'moment'

function EdicionVentaExportador (props) {
  const { data, change: formChange } = props
  const [precarga, setPrecarga] = useState(false)

  useEffect(() => {
    if (data && !precarga) {
      const exportador = `${data.razonSocialExportador} - ${data.exportador}`
      formChange('id', data.id)
      formChange('fechaVenta', data.fecha)
      formChange('exportadorVenta', exportador)
      formChange('cerealVenta', data.cereal)
      formChange('cerealVariedad', data.cerealVariedad)
      formChange('cantidad', data.cantidad)
      setPrecarga(true)
    }
  }, [data, formChange, precarga])

  const actualizarFecha = (fecha) => {
    formChange('fechaVenta', moment(fecha).format('YYYY-MM-DD'))
  }

  return (
    <div style={{ padding: '2%' }}>
      <CamposVentaExportador actualizarFecha={actualizarFecha} actualizacion />
    </div>
  )
}

const withReduxForm = reduxForm({
  form: FORM_VENTA_A_EXPORTADOR
})

export default withReduxForm(EdicionVentaExportador)
